/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import moduleProducts from './products/module.js'
import modulePurchases from './purchases/module.js'
import moduleSales from './sales/module.js'
import moduleCustomers from './customers/module.js'


import moduleUsers from './users/module'
import moduleTrucks from './trucks/module'
import moduleOperators from './operators/module'
import moduleFactory from './factory/module'
import moduleHarvests from './harvests/module'
import moduleFarms from './farms/module'
import moduleExpenses from './expenses/module'


import moduleBranches from './branches/module'
import modulePaymentOptions from './payment/module'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    users: moduleUsers,
    trucks: moduleTrucks,
    operators: moduleOperators,
    factory: moduleFactory,
    farms: moduleFarms,
    harvests: moduleHarvests,
    expenses: moduleExpenses,

    branches: moduleBranches,
    payment_options: modulePaymentOptions,

    products: moduleProducts,
    customers: moduleCustomers,
    sales: moduleSales,
    purchases: modulePurchases,
  },
  strict: process.env.NODE_ENV !== 'production'
})